import React from 'react';

import { UnitNotPassedIcon } from '../../icons/UnitNotPassedIcon';
import { UnitPassedIcon } from '../../icons/UnitPassedIcon';
import { UnitStarIcon } from '../../icons/UnitStarIcon';
import { UnitStatus } from '../models/unitStatus';
import { IUnitStatusNode } from '../models/unitStatusNode';
import { Colors } from '../../../../../design/color/Colors';

export const UNIT_LIST_ITEMS_STYLES: Record<UnitStatus, IUnitStatusNode> = {
  passed: {
    baseColor: 'rgba(46, 125, 50, 0.12)',
    color: Colors.chartSuccess,
    borderColor: 'rgba(46, 125, 50, 0.18)',
    progressColor: '#2E7D32',
    hoverColor: 'rgba(46, 125, 50, 0.18)',
    icon: <UnitPassedIcon />,
  },
  failed: {
    baseColor: '#F443361F',
    color: Colors.error,
    borderColor: '#F443362F',
    progressColor: Colors.error,
    hoverColor: '#F443362F',
    icon: <UnitNotPassedIcon />,
  },
  new: {
    baseColor: Colors.bgElevated,
    color: Colors.textPrimary,
    borderColor: Colors.border,
    progressColor: Colors.primary,
    hoverColor: Colors.bgSurface,
    icon: <UnitStarIcon />,
  },
};

export const getUnitStatus = (isPassed) => {
  if (isPassed === true) {
    return UnitStatus.Passed;
  } else if (isPassed === false) {
    return UnitStatus.Failed;
  }

  return UnitStatus.New;
};
